import React, { Component, useEffect, useState } from 'react';
import CartsView from './CartsView'
import { addItemToCrosssell, getCrosssellProducts, getOrderCache, order_key, removeFromCart, setOrderCache } from '../../utils/order_cache';
import { callCartItemListeners, getAppCfg, sortCartByProductName } from '../../utils/common'
import crmservices from '../../wsclient/crmservices';
import ModalAlert from '../../components/ModalAlert';
import t from '../../utils/translateUtil';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
function CartsController(props) {
    const [carts, setCarts] = useState(getOrderCache(order_key.cart));
    const [showAddNote, onShowAddNote] = useState(false);
    const [request_amount_from_wallet_funds, setRequestAmountFromWalletFunds] = useState(props.request_amount_from_wallet_funds);
    const [isValidAmountWalletFund, setIsValidAmountWalletFund] = useState(props.isValidAmountWalletFund);
    const [edit_amount_form, setEditAmountForm] = useState(false);
    const [input_field_value, setInputFieldValue] = useState(0);
    const [message, setMessage] = useState({});
    const [crosssellProducts, setCrosssellProducts] = useState(null);
    const [loadingCrosssell, onLoadingCrosssell] = useState(false);
    const estimate_cart_items = getOrderCache(order_key.estimate_cart_item);


    useEffect(()=>{
        onLoadCrosssellProductInfor();
    },[])
    const onLoadCrosssellProductInfor = async() =>{
        onLoadingCrosssell(true);
        var crosssellProducts = getCrosssellProducts();
        
        var fullCrosssellsInformation = []
        if (crosssellProducts.length > 0) {
            try {
                for (let i = 0; i <crosssellProducts.length ;i++){
                    var product = crosssellProducts[i];
                  // console.log('product======',product)
                    var productInfoResult = await crmservices.orders.getProductDetail(product.id);
                    if(productInfoResult.code=='OK'){
                        product = {...product, ...productInfoResult.data};
                    }
                    fullCrosssellsInformation.push(product);
                }
        } catch (error) {
            console.log("onLoadCrosssellProductInfor exception: ", error);
            }
        }
        //console.log('AAAAAAAAAAAAAAAAAAAAAAAAAA crosssellProducts detail:',fullCrosssellsInformation)
        setCrosssellProducts(fullCrosssellsInformation);
        onLoadingCrosssell(false);
    }
    const onRemoveItem = async(item) =>{

        await removeFromCart(item)
        var carts = getOrderCache(order_key.cart);
        //console.log('onRemoveItem==carts=',carts)
        setCarts(carts)
        if (carts.length == 0) {
            props.setActivePage("menu");
            addItemToCrosssell([])
        } else {
            props.onEstimateOrder(null, null, null, true);
            onLoadCrosssellProductInfor()
            setRequestAmountFromWalletFunds(undefined);
            setInputFieldValue(0);
        }
        callCartItemListeners();
    }
    const handleChangeNumberFund = (value) =>{
        validateAmountWalletFunds(value)
        setInputFieldValue(value);
    }
    const validateAmountWalletFunds = (value) =>{
        var request_amount_from_wallet_funds = value;
        var estimate_order_result = getOrderCache(order_key.estimate_order_result)
        if (request_amount_from_wallet_funds != undefined && request_amount_from_wallet_funds != null) {
           // var suggestWalletFundsAmount = estimate_order_result.invoice_estimate && estimate_order_result.invoice_estimate.wallet_funds_amount ? estimate_order_result.invoice_estimate.wallet_funds_amount : 0;
            if (request_amount_from_wallet_funds > props.availabelWalletFund) {
                setIsValidAmountWalletFund(false);
            } else {
                setIsValidAmountWalletFund(true);
            }
        }
    }
    const onPlaceOrder = async() =>{
        // console.log('note===',note)
        if (isValidAmountWalletFund == false) {
            showMessage(true, t('REQUEST_WALLET_FUNDS_AMOUNT_INVALID'))
            return;
        }

        await props.onEstimateOrder();// esstimate because check add notes cart

        
        if(props.request_amount_from_wallet_funds!=undefined && props.isUseWalletFund){
            var wallet_funds_amount = Number(props.request_amount_from_wallet_funds)
            if(wallet_funds_amount!= undefined){
                props.setRequestAmountFromWalletFunds(wallet_funds_amount);
                props.setValidAmountWalletFund(isValidAmountWalletFund)
            }
        }

        var estimate_order_result = getOrderCache(order_key.estimate_order_result);
        if (estimate_order_result && estimate_order_result.id) {
            props.setActivePage('order_preview');
        } else {
            props.onEstimateOrder();
        }
    }
    const onUseWalletFund = async() =>{

        const { isUseWalletFund, setUseWalletFund, setAvailabelWalletFund } = props;
        var use_wallet_funds = undefined;
        if(isUseWalletFund==undefined){
            use_wallet_funds = true;
        }else{
            use_wallet_funds = !isUseWalletFund;
        }
        var estimate_result = await props.onEstimateOrder(use_wallet_funds);
        var availabelWalletFund = 0;
        if(use_wallet_funds){
            let isValidateWallet = isValidateUsingWallet();
            if (isValidateWallet) {
                use_wallet_funds = true;
                availabelWalletFund = estimate_result.invoice_estimate && estimate_result.invoice_estimate.wallet_funds_amount ? estimate_result.invoice_estimate.wallet_funds_amount : 0
            } else {
                use_wallet_funds = false;
                showMessage(true, t('WALLET_FUND_INSUFFICIENT'))
            }
        }
        setUseWalletFund(use_wallet_funds);
        setAvailabelWalletFund(availabelWalletFund);
        
        
        setRequestAmountFromWalletFunds(props.request_amount_from_wallet_funds);
        setIsValidAmountWalletFund(undefined);

    }

    const isValidateUsingWallet = () =>{
        const app_config = getAppCfg();
        let allow_full_basket_wallet_fund = app_config.features && app_config.features.ordering_details ? app_config.features.ordering_details.allow_full_basket_wallet_fund : false;
        let isValidateWallet = true;
        let _estimate_order_result = getOrderCache(order_key.estimate_order_result)
        if (allow_full_basket_wallet_fund) {
            let order_summary = dataUtil.getOrderSummary(_estimate_order_result);
            let totalAmount = order_summary.amountDue;
            let walletFundAmount = order_summary.wallet_funds_amount;
            if (totalAmount > walletFundAmount) {
                isValidateWallet = false
            }
        }
        return isValidateWallet;
    }

    const onShowEditWalletFundAmount = async(type) =>{
        if(type==='save'){
            setRequestAmountFromWalletFunds(input_field_value)
            props.setRequestAmountFromWalletFunds(input_field_value);
            props.setValidAmountWalletFund(isValidAmountWalletFund);
            await props.onEstimateOrder(null, null, input_field_value)
        }
        else if(type==='cancel'){
            setInputFieldValue(0)
        }
        setEditAmountForm(!edit_amount_form)
    }
    const showMessage = (status, message) =>{
        setMessage({
            show: status,
            content: message ? message : null
        })
    }
    return (
        <div>
        <CartsView
            open={props.open}
            onClose={props.onClose}
            carts={carts.sort(sortCartByProductName)}
            currency={props.currency}
            estimate_cart_items={estimate_cart_items.sort(sortCartByProductName)}
            estimate_order_result={getOrderCache(order_key.estimate_order_result)}
            totalAmountBaseItem={props.totalAmountBaseItem}
            availabelWalletFund={props.availabelWalletFund}
            onPlaceOrder={onPlaceOrder}
            onGoBack={props.setActivePage}
            onRemoveItem={onRemoveItem}
            editCartItem={props.editCartItem}
            showAddNote={showAddNote}
            onClickAddNote={()=>onShowAddNote(!showAddNote)}
            handleOnChangeAddNote={props.handleOnChangeAddNote}
            notes={props.order_notes}
            onUseWalletFund ={onUseWalletFund}
            isUseWalletFund={props.isUseWalletFund}
            onSelectPaymentMethod={props.onShowPaymentMethod}
            paymentMethod={props.paymentMethod}
            primary_card={props.primary_card}
            primary_paypal={props.primary_paypal}
            order_type = {props.order_type}
            crosssellProducts = {crosssellProducts}
            onSelectCrossellProduct={props.onSelectCrossellProduct}
            loadingCrosssell={loadingCrosssell}
            request_amount_from_wallet_funds={request_amount_from_wallet_funds}
            isValidAmountWalletFund={isValidAmountWalletFund}
            edit_amount_form={edit_amount_form}
            onShowEditWalletFundAmount={onShowEditWalletFundAmount}
            handleChangeNumberFund={handleChangeNumberFund}
            input_field_value = {input_field_value}
        />
        {message && <ModalAlert
            open={message.show}
            onClose={showMessage}
            message={message.content}
        />}
        </div>
    );
}

export default CartsController;